module.exports = __webpack_public_path__ + "img/2.0c966258.png";